
import React from 'react';
import './feed-container.style.css';
import {
    Link,
} from 'react-router-dom'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'dayjs/locale/th'

library.add(fas);

var dayjs = require('dayjs')




const FeedContainer = (props) => {
    return (
        <div className="feed-wrap">
            <div className="feed-header">บทความล่าสุด</div>
            <div className="feed-container">

                {
                    props.firstPostsQuery ?
                        props.posts ? props.posts.map((post, i) => <FeedCard key={i} post={post} />)
                            : ""
                        :
                        <div>
                            <SkeletonFeed />
                            <SkeletonFeed />
                            <SkeletonFeed />
                            <SkeletonFeed />
                            <SkeletonFeed />

                        </div>
                }

                {(props.noMore === "empty" || props.posts.length < 5) && props.firstPostsQuery ? <EmptyNewFeed /> : ""}

            </div>
        </div>
    )
}

const EmptyNewFeed = (props) => {
    return (
        <Link to={"/newpost"}>
            <div className="feed-card empty-new-post">
                <div className="feed-empty-quote">บทความหมดแล้ว...สร้างบทความใหม่ของคุณได้เลย!</div>
            </div >
        </Link>
    )
}






const FeedCard = ({ post }) => {

    return (

        <div className="feed-card">
            <div className="feed-data">
                <div className="feed-author-staus">
                    <Link to={`/${post.userNicename}/`}>
                        <FeedAuthor authorImage={post.authorImage} authorName={post.authorName} />
                    </Link>
                    {post.status === 'draft' ? <div className="feed-publish-status">ฉบับร่าง</div> : <></>}

                </div>
                <Link className="a-link" to={`/${post.userNicename}/${post.path}`}>
                    <div class="feed-title ellipsis-two-lines">{post.title}</div>
                    <div class="feed-des ellipsis-two-lines">{post.content.replace('&nbsp;', ' ')}</div>
                </Link>

                <FeedStatus statusDate={post.date} statusReaction={post.miniheartCount} statusComment={post.commentCount} statusCategory={post.tags} />
            </div>
            <Link className="a-link" to={`/${post.authorLogin}/${post.path}`}>
                <div class="feed-image" style={{ backgroundImage: `url(${post.coverImage})` }}></div>
            </Link>
        </div >

    )
}

const FeedAuthor = (props) => {
    let handleOnClick = (event) => {
        event.stopPropagation();
    }
    return (
        <div className="feed-author" >
            <div className="feed-author-image" style={{ backgroundImage: `url(${props.authorImage})` }}>
            </div>
            <div className="feed-author-name ellipsis-text">{props.authorName}</div>
        </div>
    )
}

const FeedStatus = (props) => {
    var thaiMonth = ["มกราคม", "กุมพาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"]
    var date = props.statusDate;
    if (date) {

        date = (dayjs(props.statusDate));
        date = date['$D'] + " " + thaiMonth[date['$M']] + " " + (543 + date['$y'])
    } else {

        date = 'ยังไม่ถูกเผยแพร่'

    }


    return (
        <div className="feed-status">
            <div className="feed-status-detail">
                <div class="feed-date">{date}</div>
                <div class="feed-reaction"><FontAwesomeIcon style={{ color: "salmon" }} icon={['fas', 'heart']} fixedWidth /> {props.statusReaction}</div>
                <div class="feed-reaction"><FontAwesomeIcon style={{ color: "#FFC000" }} icon={['fas', 'comment-dots']} fixedWidth /> {props.statusComment}</div>
            </div>
            <FeedCategories category={props.statusCategory} />

        </div>
    )
}

const FeedCategories = (props) => {
    let categories = props.category
    let haveMore = false
    if (props.category != undefined && props.category.length > 3) {
        haveMore = true
        categories = (props.category.slice(0, 2))
        categories.push({ "tagName": "+" + (props.category.length - 2).toString(), "tagOfficial": "2" })
    }
    return (
        <div class="feed-categories">
            {categories ? categories.map((category, i) => <FeedCategory key={i} index={i} category={category} haveMore={haveMore} />) : ""}
        </div>
    )
}

const FeedCategory = ({ index, category, haveMore }) => {

    const bgColor = category.tagOfficial === "1" ? category.tagColor1 : "#3C3C3C";
    const textColor = category.tagOfficial === "1" ? category.tagColor2 : "white";



    return (
        <>
            {category.tagOfficial !== "2" ?
                <Link className="a-link" to={`/tag/${category.tagName}`}>
                    <div className="feed-tag ellipsis-text" style={{ backgroundColor: bgColor, color: textColor }} >
                        {category.tagName}
                    </div>
                </Link>
                :
                <div className="feed-tag " style={{ backgroundColor: bgColor, color: textColor }}>
                    {category.tagName}
                </div>}

        </>
    )
}

const SkeletonFeed = (props) => {
    return (
        <div className="feed-card">
            <div className="feed-data">
                <div className="feed-author" >
                    <div className="feed-author-image" style={{ backgroundColor: " rgb(56, 56, 56)" }}>
                    </div>
                    <div className="feed-skeleton" style={{ width: "150px", marginTop: "9px", marginLeft: "5px" }}></div>
                </div>
                <div className="feed-skeleton" style={{ width: "300px", height: "30px", marginTop: "10px" }}></div>
                <div className="feed-skeleton" style={{ width: "80%", marginTop: "10px" }}></div>
                <div className="feed-skeleton" style={{ width: "80%", marginTop: "4px" }}></div>
            </div>
            <div class="feed-image" style={{ backgroundColor: " rgb(56, 56, 56)" }}></div>

        </div >
    )
}

export default FeedContainer;

export { FeedCard, SkeletonFeed }



